import React from "react"
import HotTable from "../../../utils/hot-table"
import SubTableRenderer from './sub-table-renderer'
import CellRenderer from './cell-renderer'
import DeleveragingYearsCell from "./delevaraging-years-cell"
import DeleveragingYearsWarningCell from "./deleveraging-years-warning-cell"
import WarningCell from "./warning-cell"
import { formatDeleveragingYears } from "../../../../domain/sfp/cash-flow-domain";

class SFPHotTable extends React.Component {

    render() {
        return (
            <HotTable
                ref="table"
                root={this.props.root}
                afterChange={this._handleChange.bind(this)}
                settings={this._getSettings()}
                beforeKeyDown={this._handleKeyDown.bind(this)}
                previousYear={this.props.previousYear}
            />
        )
    }


    componentDidMount() {
        if (!window.hot_instances) window.hot_instances = []

        var index = window.hot_instances.map(h => (h.root)).indexOf(this.props.root)
        if (index !== -1) {
            window.hot_instances.splice(index, 1)
        }

        window.hot_instances.push({ root: this.props.root, instance: this })
        /*
        this.updateDimensions()
        window.addEventListener("resize", this.updateDimensions.bind(this));
        window.addEventListener("scroll", this.updateDimensions.bind(this), false);
        */
    }

    componentWillUnmount() {
        if (window.hot_instances) {
            window.hot_instances.splice(window.hot_instances.map(h => (h.root)).indexOf(this.props.root), 1)
        }
    }

    _getSettings = () => {
        var headers = this.props.headers
        if (headers) {
            headers.unshift(this.props.title || "")
        }

        const mergedAreas = this.props.tableDefinition.rows.filter(row => (row.rowComponent || row.isHeader)).map(row => {
            return {
                row: row.index,
                col: 0,
                rowspan: 1,
                colspan: this.props.headers.length
            }
        })

        var row
        return {
            allowInsertRow: false,
            data: this.props.data,
            fillHandle: "vertical",
            //height        : 600,
            //readOnly      : this.props.isViewContext,
            colHeaders: headers,
            renderAllRows: true,
            viewportColumnRenderingOffset: 200,
            //rowHeaderWidth: 300,
            //rowHeaders    : TableDefinition.rows.map(row => row.title),
            stretchH: "all",
            mergeCells: mergedAreas,
            colWidths: [200],
            cells: (r, c, prop) => {
                let cellProps = {}
                row = this.props.tableDefinition.rows[r]
                if (c > 0) {
                    cellProps = JSON.parse(JSON.stringify(row.cellProps || {}))
                    cellProps.readOnly = row.readOnly || false
                    cellProps.disableVisualSelection = row.readOnly || false
                } else {
                    cellProps.readOnly = true
                }

                if (row.className) { cellProps.className = row.className }

                if (row.editableCells) {
                    if (row.editableCells.indexOf(c) == -1) {
                        cellProps.readOnly = true
                    } else {
                        cellProps.readOnly = false
                    }
                }

                if (row.disabledCells) {
                    if (row.disabledCells.indexOf(c) !== -1) {
                        cellProps.readOnly = true
                    }
                }


                if (row.rowComponent && c == 0) {
                    cellProps.renderer = SubTableRenderer(row, this.props)
                } else if (row.cellComponents) {
                    var cellComponent
                    if (cellComponent = row.cellComponents.find(cl => cl.index == c)) {
                        cellProps.renderer = CellRenderer(cellComponent, row, this.props)
                    }
                }

                if (row.key === "BALANCED_PPI") {
                    if (this.props.data[r][c] < 0)
                        cellProps.className += " danger"
                }
                if (c === 1 && this.props.previousYear === true && (this.props.currentUserType !== "ADMIN" && this.props.currentUserType !== "ADMIN_REGION")) {
                    cellProps.readOnly = true
                }

                if ("BRUTE_CAF" === row.key
                    || "CAF_DEVELARGING" === row.key
                    || "DEBT_REFUND_PERCENTILE" === row.key
                ) {
                    const cellComponent = { component: WarningCell }
                    const localAuthority = this.props.currentLocalAuthority
                    const props = { ...this.props }
                    const value = this.props.data[r][c]

                    switch (row.key) {
                        case "BRUTE_CAF":
                            if (localAuthority.minimumGrossCashFlow
                                && value < localAuthority.minimumGrossCashFlow
                            ) {
                                const euroFormatter = new Intl.NumberFormat(
                                    navigator.language,
                                    { style: "currency", currency: "EUR" })
                                const formattedMinimumGrossCashFlow = euroFormatter.format(
                                    localAuthority.minimumGrossCashFlow || 0)
                                props.message = `La CAF brute du PPI est inférieur à
									l’objectif de ${formattedMinimumGrossCashFlow}`
                                cellProps.className += " danger"
                                cellProps.renderer = CellRenderer(cellComponent, row, props, c)
                            }
                            break
                        case "CAF_DEVELARGING":
                            if (localAuthority.maximumDeleveragingYears
                                && value > localAuthority.maximumDeleveragingYears
                            ) {
                                cellComponent.component = DeleveragingYearsWarningCell
                                const formattedMaxDelevYears = formatDeleveragingYears(
                                    localAuthority.maximumDeleveragingYears
                                )
                                props.message = `Le nombre d’année de désendettement est
								supérieur à l’objectif de ${formattedMaxDelevYears}`
                                cellProps.className += " danger"
                                cellProps.renderer = CellRenderer(cellComponent, row, props, c)
                            } else if (0 !== c) {
                                cellComponent.component = DeleveragingYearsCell
                                cellProps.renderer = CellRenderer(cellComponent, row, props, c)
                            }
                            break
                        case "DEBT_REFUND_PERCENTILE":
                            if (localAuthority.maximumDebtRefund
                                && value > localAuthority.maximumDebtRefund
                            ) {
                                const percentFormatter = new Intl.NumberFormat(
                                    navigator.language, { style: "percent" })
                                const formattedMaximumDebtRefund = percentFormatter.format(
                                    localAuthority.maximumDebtRefund || 0)
                                props.message = `Le % de remboursement de la CAF est supérieur à
									l’objectif ${formattedMaximumDebtRefund}`
                                cellProps.className += " danger"
                                cellProps.renderer = CellRenderer(cellComponent, row, props, c)
                            }
                            break
                    }
                }

                return cellProps
            },
        }
    }

    _handleChange = (
		/** @type {CellInfo[]} */ cells,
		/** @type {String} */   source) => {
        //this.updateDimensions()
        if (this.props.onChange) {
            if (cells !== null && cells.length > 0 && cells[0].indexOf("") !== -1) {
                const indexOfNull = cells[0].indexOf("")
                cells[0][indexOfNull] = 0
            }
            this.props.onChange(this.props.root, cells, source)
        }
    }

    _handleKeyDown(e) {
        window.hot_instances.map(h => {
            if (h.root !== this.props.root) {
                h.instance.handleSubTableKeyDown(e)
            }
        })
    }

    handleSubTableKeyDown(e) {
        if (this.refs.table) {
            let editor = this.refs.table.hotInstance.getActiveEditor()
            if (editor) {
                switch (e.keyCode) {
                    case 13:
                        editor.finishEditing()
                        break
                    case 8:
                        if (editor.getValue()) {
                            let value = editor.getValue().substr(0, editor.getValue().length - 1)
                            editor.setValue(value == "" ? null : value)
                        }
                        break
                }
            }
        }
    }

}

export default SFPHotTable



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/utils/hot-table.js